import Vue from 'vue';

export default class fvSystemApi {
    constructor(system){
        this.system = system;
        this.alreadyRegTags = [];
    }
    /*
        参数：   oldName ：默认选中
                isMidVar ： 是否显示中间变量
                isDataSource ： 是否显示数据库变量
                isLong : 是否返回点长名
        返回值：Promise对象，成功时返回点名称
        说明：打开点选择对话框
    */
    selectTagsShow(oldName,isMidVar=false,isDataSource=true,isLong=true){
        this.system.tagsDialog.$.create(this.system.tagsTreeData);
        return new Promise((resolve) => {
            this.system.tagsDialog.$.show(oldName,isMidVar,isDataSource,isLong,function(tagName){
                resolve(tagName);
            });
        });
    }
    //手机端的点选择
    selectDataShow(oldName,isMidVar=false,isDataSource=true,isLong=true){
        return new Promise((resolve) => {
            this.system.dataDialog.$.show(oldName,isMidVar,isDataSource,isLong,function(tagName){
                resolve(tagName);
            });
        });
    }
    /*
        参数：   tagsName ：点名称
        返回值： 点已注册时返回点信息，没有注册时向服务注册点，返回 Promise 对象  返回true 注册点  返回false 为失败
        说明：获取实时数据，当点没有注册时向服务注册点
    */
    getReal(tagsName){
        //添加$字段来适应对以数字开头的点
        tagsName = tagsName.substr(0,tagsName.length-3);
        tagsName = "$"+tagsName.split('.').join('.$')
        if(typeof tagsName == "string"){
            var names = tagsName.split(".");
            var result;
            if(window.__dbTags){
                result = window.__dbTags[names[0]];
            }
            for(var i = 1;i < names.length;i++){
                if(result === undefined){
                    break;
                }
                result = result[names[i]];
            }
            if(result != undefined){
                return result;
            }else{
                var pArr = tagsName.split(".");
                var p = pArr[pArr.length - 1];
                if(this.system.$.tagConfig[p]){
                    tagsName = tagsName.replace("." + p ,"");
                }
                //
                this.alreadyRegTags.push(tagsName);
                this.system.$.dbCom.declareTags([{firstValue:0,name:tagsName}]);
                this.system.$.dbCom.sendMessage({
                    head : "registryTag",
                    dbVar : [tagsName]
                },(result)=>{});
                return true;
            }
        }else{
            console.warn("点名称错误，只能是字符串类型");
            return false;
        }
    }
    /*
        参数： 无
        返回值： 无
        说明：注销点

    */
    endReal(callback){
        this.system.$.dbCom.sendMessage({
            head : "unRegistryTag",
            dbVar : this.alreadyRegTags
        },(result)=>{
            if(typeof callback == "function"){
                callback();
            }
        });
    }
    /*
        参数：   tagsStruct ：获取历史数据报文
        返回值： Promise对象
        说明：获取历史数据
    */
    getHistory(tagsStruct){
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage(tagsStruct,(err,result)=>{
                if(err){
                    reject(err);
                }else{
                    resolve(result);
                }
            });
        })
    }
    /*获取统计值方法*/
    getHistoryStatisData(tagsStruct){
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage(tagsStruct,(err,result)=>{
                if(err){
                    reject(err);
                }else{
                    resolve(result);
                }
            });
        })
    }
    /*
        参数：   data ：获取报警中心数据报文
        返回值： 数据
        说明：获取报警中心数据
    */
    getAlarmData(data){
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage(data,(err,result) => {
                if(err){
                    reject(err);
                }else{
                    resolve(result);
                }
            })
        })
    }
    /*
        参数：   data ：获取日志数据报文
        返回值： 数据
        说明：日志数据
    */
    getLogData(data){
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage(data,(err,result) => {
                if(err){
                    reject(err);
                }else{
                    resolve(result);
                }
            })
        })
    }
    /*
        参数:script函数指针或函数体字符串
             param 函数需要传递的参数
        返回值:执行的函数的返回值
        说明:执行脚本
    */
    async executionScript(script,...param){
        return await this.system.$.executionScript(script,param);
    }
    /*
        参数:name关系库连接名称
             sql 需要执行的sql语句
        返回值:sql语句执行结果
        说明:指定关系库连接执行sql语句
    */
    getDataformRDB(name,sql){
        var _getTypeFromString = function(connectString){
            var type = "sqlServer"
            var dataBaseType = connectString.match(/Provider=([^;]*);/)[1];
            if(dataBaseType == "SQLOLEDB.1" || dataBaseType == "SQLOLEDB.1"){
                type = "sqlServer";
            }else if(dataBaseType == "OraOLEDB.Oracle" 
                        || dataBaseType == "OraOLEDB.Oracle.1" 
                        || dataBaseType == "MSDAORA.1"
                        || dataBaseType == "{Oracle  in  instantclient_12}"){
                type = "oracel";
            }else if(dataBaseType == "{MySQL}" || dataBaseType == "{MySQL ODBC 3.51Driver}" 
                        || dataBaseType == "{MySQL ODBC 3.51Driver}"
                        || dataBaseType == "MySQLProv"
                        || dataBaseType == "myServerAddress"
                        || dataBaseType == "myServerAddress1"){
                            type = "mySql";
            }
            return type; 
        }
        var connectString = this.system.$.getConnectStr(name);
        return new Promise((resolve,reject) => {
            this.system.$.dbCom.sendMessage({
                head : "dataformRDB",
                message : {
                    type : _getTypeFromString(connectString),
                    connectString : connectString,
                    sql : sql
                }
                
            },(err,result)=>{
                if(err){
                    reject(err);
                }else{
                    resolve(result);
                }
            });
        })
    }
    //获取当前用户名
    getCurrentUser(){
        return this.system.$.getUserName();
    }

    getResource(key){
        return this.system.$.getResource(key);
    }

    isDbVar(val) {
        this.system.$.dbCom.isDbVar(val);
    }
}


// WEBPACK FOOTER //
// ./src/js/fvSystemApi.js